import { render, staticRenderFns } from "./applicants.vue?vue&type=template&id=fe79182a&scoped=true"
import script from "./applicants.vue?vue&type=script&lang=js"
export * from "./applicants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe79182a",
  null
  
)

export default component.exports